import { render } from "./ChatMessageBox.vue?vue&type=template&id=59175d00"
const script = {}

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__